import { connect } from 'react-redux'
import { doOpen as openLightbox } from 'actions/lightbox'
import { selectDeviceTypeIsDesktop } from 'selectors/app'
import { selectTicketDraftAttachments } from 'selectors/attachments'
import Attachments from './view'

const selectFactory = (initialState, initialOwnProps) => {
  const { forDraft } = initialOwnProps
  if (forDraft) {
    return state => {
      return {
        attachments: selectTicketDraftAttachments(state),
        deviceTypeIsDesktop: selectDeviceTypeIsDesktop(state),
      }
    }
  }
  return state => {
    return {
      deviceTypeIsDesktop: selectDeviceTypeIsDesktop(state),
    }
  }
}

const perform = {
  onClickImage: openLightbox,
}

export default connect(selectFactory, perform)(Attachments)
